/* eslint-disable react/no-danger */
import React from 'react';
import moment from 'moment';
import { Button } from 'antd';
import { api } from '@unicus/react-ui-kit';
import { DownloadOutlined } from '@ant-design/icons';
import HtmlEditor from 'components/HtmlEditor/HtmlEditor';

const SectionFieldDocument = ({
  id,
  name,
  text,
  creationTime,
  lastModificationTime
}) => {
  const handleDownload = () => {
    const url = api.getUrlFromResource(`attendances/${id}/document-pdf`);
    window.open(url);
  };

  return (
    <div className="gx-mt-4">
      <div className="gx-fs-lg gx-font-weight-bold gx-mb-1">{name}</div>
      <div className="gx-fs-11">
        {moment(creationTime).format('[Criado em] DD/MM/YYYY HH:mm')}
      </div>
      {lastModificationTime ? (
        <div className="gx-fs-11">
          {moment(lastModificationTime).format(
            '[Atualizado em] DD/MM/YYYY HH:mm'
          )}
        </div>
      ) : null}
      <div className="gx-mt-2" dangerouslySetInnerHTML={{ __html: text }} />
      <div className="gx-mt-2">
        <Button
          size="small"
          icon={<DownloadOutlined />}
          onClick={handleDownload}
        >
          Imprimir
        </Button>
      </div>
    </div>
  );
};

export default SectionFieldDocument;
